import { Injectable, Optional } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormMessageService } from '../form-message.service';
import { LanguageService } from '../languag.service';
import { HttpUtil, HttpStatusType } from '../util/http';

/**
 * è¡¨åéè¯¯æç¤ºæå¡
 * @description ç»ä¸å¤çååç«¯å¼å¸¸
 */
@Injectable()
class FormErrorService {
  constructor(
    private msgService: FormMessageService,
    @Optional() private languageService: LanguageService
  ) {
  }

  /**
   * å¼å¸¸è·¯ç±æ¹æ³
   */
  public exception(message: string, error: any) {
    // éå¯¹sessionå¤±æåç¹æ®å¤ç
    if (error && error.hasOwnProperty('expired') && error['expired'] === true) {
      return;
    }
    if (error && this.isHttpErrorResponse(error)) {
      this.httpErrorHandler(error);
    } else {
      // todo: ç»åå¼å¸¸å¤çåï¼ç»§ç»­æè§£è¯¥æ¹æ³
      this.commonErrorHandler(message);
    }
  }

  /**
   * httpè¯·æ±å¼å¸¸å¤çå¨
   */
  public httpErrorHandler(httpError: HttpErrorResponse): void {
    if (!httpError) {
      return;
    }

    const statusType = HttpUtil.getHttpStatusType(httpError.status);

    switch (statusType) {
      case HttpStatusType.ClientError:
        if (httpError.status === 401) {
          this.msgService.http401Error(httpError);
          break;
        }
        this.msgService.httpErrorInClient(httpError);
        break;
      case HttpStatusType.ServerError:
        this.msgService.httpErrorInServer(httpError);
        break;
      default:
        throw new Error('Get invalid status code when using httpErrorHandler method.');
    }
  }

  private commonErrorHandler(errorMsg: string): void {
    if (!errorMsg) {
      return;
    }
    this.msgService.error(errorMsg);
  }
  /**
   * httpErrorResponse like
   * @param error å¼å¸¸
   */
  private isHttpErrorResponse(error) {
    if (!error) {
      return false;
    }
    if (typeof error !== 'object') {
      return false;
    }
    if (error.name === 'HttpErrorResponse' && error.hasOwnProperty('status') && error.hasOwnProperty('error')) {
      return true;
    }
    if (error instanceof HttpErrorResponse) {
      return true;
    }
    return false;
  }
}

export { FormErrorService };

